<template lang="pug">
  main.main.main_cancel(v-if="!loading")
    header.main__header
      h1.main__title {{ $t('cancel.title') }}
    .main__container
      .main__content
        form.form.form_cancel(@submit.prevent="onSubmit")
          .form__row
            label.form__label {{ $t('cancel.labels.delivery') }}
            .radio.radio_cancel.form__radio
              input.radio__input(
                type="radio"
                name="delivery",
                id="kiev",
                v-model="fields.delivery",
                value="kiev"
              )
              label.radio__label(for="kiev")
                .radio__label-row
                  .radio__label-title {{ $t('cancel.radios.kiev.label') }}
                  .radio__price {{ $t('cancel.radios.kiev.price') }}
                .radio__more(v-if="fields.delivery === 'kiev'")
                  .radio__text {{street}}, {{home}}, {{room}}
                  router-link.radio__link(to="/cancelWhereDelivery") {{ $t('cancel.radios.kiev.link') }}
            .radio.radio_cancel.form__radio
              input.radio__input(
                type="radio",
                name="delivery",
                id="pickup",
                v-model="fields.delivery",
                value="pickup"
              )
              label.radio__label(for="pickup")
                .radio__label-row
                  .radio__label-title {{ $t('cancel.radios.pickup.label') }}
                  .radio__price {{ $t('cancel.radios.pickup.price') }}
                .radio__description {{ $t('cancel.radios.pickup.description') }}
            .radio.radio_cancel.form__radio
              input.radio__input(
                type="radio",
                name="delivery",
                id="np",
                v-model="fields.delivery",
                value="np"
              )
              label.radio__label(for="np")
                .radio__label-row
                  .radio__label-title {{ $t('cancel.radios.np.label') }}
                  .radio__price {{ $t('cancel.radios.np.price') }}
                .radio__more(v-if="fields.delivery === 'np'")
                  .form__select
                    v-select(:options="options" label="title" v-model="fields.np" class="custom-select" :placeholder="$t('cancel.placeholders.np')")
                      template(slot="option" slot-scope="option" class="custom-select__option") {{ option.title }}
                  label.form__label {{ $t('cancel.labels.fio') }}
                  .form__field
                    .form__field-input
                      input.form__input(v-model="$v.fields.fio.$model" :class="{'form__input_error': !$v.fields.fio.minLength}")
                    span.form__error-text(v-if="!$v.fields.fio.minLength") {{ $t('cancel.errors.fio') }}
          footer.form__footer
            input.button.form__button(
              type="submit",
              :value="$t('cancel.buttons.cancel')"
              :disabled="isDisabled"
            )
            a.link-back(@click="$router.go(-1)") {{ $t('cancel.buttons.back') }}
</template>
<script>
import Vue from 'vue'
import vSelect from 'vue-select'
import { required, minLength } from 'vuelidate/lib/validators'
import { mapGetters } from 'vuex'

Vue.component('v-select', vSelect)

export default {
  name: 'Cancel',
  data () {
    return {
      fields: {
        delivery: undefined,
        np: undefined,
        fio: undefined
      },
      loading: false,
      options: ['Поломка', 'Поломка1', 'Поломка2']
    }
  },
  validations: {
    fields: {
      fio: {
        required,
        minLength: minLength(4)
      },
      np: {
        required
      },
      delivery: {
        required
      }
    }
  },
  methods: {
    fetchData () {
      this.loading = true
      this.$store.dispatch('getAddressDelivery').then(response => {
        this.loading = false
      })
    },
    onSubmit () {
      this.$store.dispatch('cancelOrder', this.fields)
    }
  },
  computed: {
    ...mapGetters({
      street: 'getAddressDeliveryStree',
      home: 'getAddressDeliveryHome',
      room: 'getAddressDeliveryRoom'
    }),
    isDisabled () {
      if (this.fields.delivery !== 'np' && !this.$v.fields.delivery.$invalid) {
        return false
      }
      return this.$v.fields.$invalid
    }
  },
  created () {
    this.fetchData()
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Cancel.vue